module.exports = __webpack_public_path__ + "img/amazonec2-black.d1821012.svg";